// extracted by mini-css-extract-plugin
export default {"uploaded":"FileUploadButton_uploaded__BXOWl","button":"FileUploadButton_button__mlAwv"};